<template>
  <div class="page p-home-new">

    <div class="icon-menu">
      <div class="icon logga"></div>
    </div>

    <div class="content">
      <div class="text-intro">
        <h1>{{ $lang.m_intro_header }}</h1>
        <div class="ing-wrapper">
          <h4 v-html="$lang.m_intro_content"></h4>
        </div>
      </div>

      <div class="parts-intro pure-g">
        <div class="pure-u-1-1 pure-u-md-1-3 f-p-i">
          <div class="icon-nr first">
            <h2>1</h2>
          </div>
          <p v-html="$lang.dot_1_txt"></p>
        </div>

        <div class="pure-u-1-1 pure-u-md-1-3 s-p-i">
          <div class="icon-nr second">
            <h2>2</h2>
          </div>
          <p v-html="$lang.dot_2_txt"></p>
        </div>

        <div class="pure-u-1-1 pure-u-md-1-3 t-p-i">
          <div class="icon-nr third">
            <h2>3</h2>
          </div>
          <p v-html="$lang.dot_3_txt"></p>
        </div>
      </div>

      <div class="btn-wrapper">
        <div class="btn arrow white" v-touch:tap="toPartOverview">
          <p>{{ $lang.next }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'page-home',
  data () {
    return {
      overlay: false
    }
  },
  beforeMount () {
    this.util.addBodyClass('home-page')
  },
  mounted () {
    // this.setLowestBtn()
  },
  methods: {
    setLowestBtn () {
      let first = this.$refs.nextBtnOne.offsetTop
      let second = this.$refs.nextBtnTwo.offsetTop
      let extraMargin = (first > second) ? (first - second) : (second - first)

      if (first > second && extraMargin < 200) {
        this.$refs.nextBtnTwo.style = ('margin-top: ' + (extraMargin + 16) + 'px;')
      } else if (second > first && extraMargin < 200) {
        this.$refs.nextBtnOne.style = ('margin-top: ' + (extraMargin + 16) + 'px;')
      }
    },
    toggleOverlay () {
      let self = this
      return self.onToggleOverlay()
    },
    onToggleOverlay () {
      this.overlay = !this.overlay
    },
    goTo (to) {
      let self = this
      return () => {
        self.onGoTO(to)
      }
    },
    onGoTO (to) {
      this.$router.push({name: to})
    },
    toPartOverview () {
      let self = this
      return self.onToPartOverview()
    },
    onToPartOverview () {
      this.$router.push({name: 'Oversight'})
    }
  },
  beforeDestroy () {
    this.util.removeBodyClass('home-page')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/home/index.vue